/* eslint-disable */
import React, { Component } from 'react';
import logger from './.././../logger';

class DeezerPlayerLarge extends Component {

    state = {
        songid: 0
    }

    componentWillReceiveProps(nextProps) {
        this.setState({songid: nextProps.songid})
    }

    render() {
        let dezzerSource = `https://www.deezer.com/plugins/player?format=classic&autoplay=${this.props.autoplay}&playlist=true&width=300&height=300&color=ffffff&layout=&size=small&type=tracks&id=${this.props.songid}&app_id=1`;
        return(
            <iframe id="deezer_player" title="deezer_player"scrolling="no"frameBorder="0"allowtransparency="true"
            src={dezzerSource} width="300"height="100" ></iframe>
        );
    }
};

export default DeezerPlayerLarge;